import React, { useState, useRef, Fragment } from 'react'
import { create as ipfsHttpClient } from 'ipfs-http-client'
const ipfs = ipfsHttpClient('https://ipfs.infura.io:5001/api/v0')

export const ImageUpload = ({ setUrl, setMediaUrl, onlyButton, buttonText = "Select image", classNameSubmit, prepareUpload }) => {
    const [image, setImage] = useState({})
    const [imagePreview, setImagePreview] = useState('')
    const [loading, setLoading] = useState(false)
    const [uploaded, setUploaded] = useState(false)
    const inputFile = useRef(null)

    const createPreview = (e) => {
        if (e.target.value !== '') {
            setImage(e.target.files[0])
            const src = URL.createObjectURL(e.target.files[0])
            setImagePreview(src)
            setMediaUrl(src)
            if (typeof prepareUpload === 'function') {
                prepareUpload(true)
            }
        } else {
            setImagePreview('')
        }
    }

    const resetUpload = (e) => {
        e.preventDefault()
        setUrl(false)
        setImagePreview('')
        setUploaded(false)
        setLoading(false)
    }

    const uploadFile = async (e) => {
        setLoading(true)
        e.preventDefault()

        try {
            const added = await ipfs.add(image)
            const url = `https://ipfs.infura.io/ipfs/${added.path}`
            setUrl(url)
            setImagePreview(url)
            setUploaded(true)
        } catch (err) {
            console.log('Error uploading the file : ', err)
        }
        setLoading(false)
    }

    const previewAndUploadButton = () => {
        if (imagePreview !== '' && !onlyButton) {
            if (!loading) {
                return (
                    <div>
                        {uploaded ? (
                            <h5>
                                ✅{' '}
                                <a
                                    href={imagePreview}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    Image
                                </a>{' '}
                                Uploaded Successfully ✅{' '}
                            </h5>
                        ) : (
                            <div className='mt-3'>
                                <button type='submit' className='inline-flex justify-center py-2 px-4 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-md border border-transparent focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 shadow-sm'>
                                    Upload Image
                                </button>
                                
                                <h5 className='mt-3 mb-3'>
                                    {image.name}{' '}
                                    <span className='bg-green-100 text-green-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900'>
                                        {image.size} kb</span>
                                </h5>

                                <img
                                    style={{ height: '269px' }}
                                    className='box-content h-32 w-32 p-3 border-3 mb-3'
                                    src={imagePreview}
                                />
                            </div>
                        )}
                    </div>
                )
            } else {
                return (
                    <div className="grid grid-cols-1 gap-y-6 mt-4 sm:grid-cols-3 sm:gap-x-4">
                        <h4>Uploading Image</h4>
                        <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                            <div className="bg-blue-600 h-2.5 rounded-full" style="width: 69%"></div>
                        </div>
                        <h4>Please Wait ...</h4>
                    </div>
                )
            }
        }
    }

    return (
        <div>
            <form onSubmit={uploadFile}>
                {onlyButton ? (
                <Fragment>
                <input
                  required
                  ref={inputFile}
                  type='file'
                  accept='image/*'
                  onChange={(e) => createPreview(e)}
                  className='invisible'
                  style={{position: 'absolute', left: 0, opacity: 0}}
                />
                {imagePreview && !uploaded ? (
                    <button 
                    type='submit'
                    className='py-2 px-3 ml-3 text-sm font-medium leading-4 text-gray-700 bg-white hover:bg-gray-50 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 shadow-sm'>
                    {loading ? 'Uploading...' : 'Upload Image'}
                    </button>
                )
                : uploaded && (
                    <button 
                    type='reset'
                    onClick={(e) => resetUpload(e)}
                    className='py-2 px-3 ml-3 text-sm font-medium leading-4 text-gray-700 bg-white hover:text-white hover:bg-red-500 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 shadow-sm'>
                    Reset
                    </button>
                ) || !uploaded && (<button
                  onClick={() => inputFile.current.click()}
                  type="button"
                  className={classNameSubmit}
                >
                  {buttonText}                
                </button>)}
                </Fragment>
                ):          
                (
                <input
                    required
                    type='file'
                    accept='image/*'
                    onChange={(e) => createPreview(e)}
                    className='p-3 text-sm bg-white rounded border-0 focus:outline-none focus:ring shadow transition-all duration-150 ease-linear placeholder:text-blueGray-300 text-blueGray-600'
                />
                )}
                {previewAndUploadButton()}
            </form>
        </div>
    )
}
